import { ApiClientWrapper, createApiClientWrapper } from '@spike/api-client';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { RootState, store } from 'store';
import { v4 as uuid } from 'uuid';

const abortController = new AbortController();

const config: AxiosRequestConfig = {
    baseURL: `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_API_BASE_URL}`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

export const ApiClient: AxiosInstance = axios.create(config);

const publicConfig: AxiosRequestConfig = {
    baseURL: `${process.env.REACT_APP_HOST_URL}${process.env.REACT_APP_API_PUBLIC_BASE_URL}`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

export const ApiPublicClient: AxiosInstance = axios.create(publicConfig);

export const createTokenConfig = (): AxiosRequestConfig => {
    const token = store.getState().auth.token;

    if (token) {
        return {
            headers: {
                Authorization: `Bearer ${token}`
            },
            signal: abortController.signal
        };
    } else {
        return {};
    }
};

export const createMultipartTokenConfig = (): AxiosRequestConfig => {
    const tokenConfig = createTokenConfig();
    return {
        ...tokenConfig,
        headers: {
            ...tokenConfig.headers,
            'Content-Type': 'multipart/mixed'
        },
        signal: abortController.signal
    };
};

export const createWrapper = (state: RootState): ApiClientWrapper => {
    const masterData = state.masterData.data;
    const marketplace = state.marketplace.data;

    return createApiClientWrapper(
        ApiClient,
        createTokenConfig(),
        createMultipartTokenConfig(),
        Number(marketplace.id),
        String(marketplace.timeZone),
        masterData,
        uuid,
        marketplace
    );
};
